const OUTPUT_DIRECTORY = "exports";

export function hasOpfs(): boolean {
  return typeof navigator.storage?.getDirectory === "function";
}

export async function createOpfsOutput(name: string): Promise<{
  handle: FileSystemFileHandle;
  writable: FileSystemWritableFileStream;
}> {
  const directory = await getOutputDirectory();
  const handle = await directory.getFileHandle(name, { create: true });
  const writable = await handle.createWritable();
  return { handle, writable };
}

export async function getOpfsFile(name: string): Promise<File> {
  const directory = await getOutputDirectory();
  return (await directory.getFileHandle(name)).getFile();
}

export async function removeOpfsFile(name: string): Promise<void> {
  if (!hasOpfs()) return;
  const directory = await getOutputDirectory();
  await directory.removeEntry(name).catch(() => undefined);
}

async function getOutputDirectory(): Promise<FileSystemDirectoryHandle> {
  if (!hasOpfs()) throw new Error("OPFSがこのブラウザで利用できません");
  const root = await navigator.storage.getDirectory();
  return root.getDirectoryHandle(OUTPUT_DIRECTORY, { create: true });
}
